import { administrationRequests } from "api/administrationApi";
import React from "react";
import { ReferenceField, TextField } from "react-admin";

const DirectionField = () => (
  <ReferenceField
    source="directionId"
    reference={administrationRequests.getDirectionsSelect()}
  >
    <TextField source="name" />
  </ReferenceField>
);

export default DirectionField;
